import { render, staticRenderFns } from "./QuotesCreate.vue?vue&type=template&id=0823d614"
import script from "./QuotesCreate.vue?vue&type=script&lang=js"
export * from "./QuotesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports